import useLocalStorage from '../hooks/useLocalStorage';

const Auth = () => {
  const [storedValue] = useLocalStorage('AUTH', localStorage.getItem('AUTH'));
  if (storedValue) {
    return true;
  }
  return false;
};

export default Auth;
